import { render, staticRenderFns } from "./CardUserAction.vue?vue&type=template&id=60d56ea1&scoped=true"
import script from "./CardUserAction.vue?vue&type=script&lang=js"
export * from "./CardUserAction.vue?vue&type=script&lang=js"
import style0 from "./CardUserAction.vue?vue&type=style&index=0&id=60d56ea1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d56ea1",
  null
  
)

export default component.exports